import { Stack } from '@mui/material';
import React, { useState } from 'react';
import ReverseSwitch from '../../../../../components/material-ui/ReverseSwitch';
import CusCheckbox from '../../../../../components/material-ui/CusCheckbox';

export default function GoogleAuth({ updateParamCasino }) {
  const [isGoogle, setIsGoogle] = useState(false);
  const [isAutomatically, setIsAutomatically] = useState(false);

  return (
    <Stack direction={'row'} gap={1}>
      <ReverseSwitch
        label={'via Google account'}
        checked={isGoogle}
        onChange={() => {
          setIsGoogle((prev) => !prev);
          updateParamCasino({ googleRegEnabled: !isGoogle });
        }}
      />

      <CusCheckbox
        label="automatically show the login window"
        checked={isAutomatically}
        onChange={() => {
          setIsAutomatically((prev) => !prev);
          updateParamCasino({ automatically: !isAutomatically });
        }}
      />
    </Stack>
  );
}
